module.exports = __webpack_public_path__ + "files/f31e9a1309c32b41dd494c72a4a9b419.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/android-chrome-192x192.png
// module id = 549
// module chunks = 76